import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {
    NotificacionWeb,
    PedidoCatalogoNotificacionWebPayload,
    PedidoMenuNotificacionWebPayload
} from '@app/domain/notificacion-web';

@Injectable({
    providedIn: 'root'
})
export class NotificacionWebActionService {

    constructor(private messageService: MessageService,
                private router: Router) {
    }

    execute(notification: NotificacionWeb, beforeNavigate: () => void): void {
        const payload = notification.payload;
        switch (notification.codigo) {
            case 'PEDIDO_CATALOGO':
                if (!payload) {
                    this.showWarning('La notificación no contiene una acción válida.');
                    return;
                }
                this.openPedidoDetail(payload as PedidoCatalogoNotificacionWebPayload, beforeNavigate);
                break;
            case 'PEDIDO_MENU':
                if (!payload) {
                    this.showWarning('La notificación no contiene una acción válida.');
                    return;
                }
                this.openPedidoDetail(payload as PedidoMenuNotificacionWebPayload, beforeNavigate);
                break;
            default:
                beforeNavigate();
                break;
        }
    }

    openPedidoById(idPedido: number, beforeNavigate: () => void = () => {}): void {
        beforeNavigate();
        this.router.navigate(['/ventas/pedidos-tienda-online', idPedido]);
    }

    private openPedidoDetail(payload: PedidoCatalogoNotificacionWebPayload | PedidoMenuNotificacionWebPayload,
                             beforeNavigate: () => void): void {
        const idPedido = this.resolvePedidoId(payload);
        if (idPedido == null) {
            return;
        }
        this.openPedidoById(idPedido, beforeNavigate);
    }

    private resolvePedidoId(payload: PedidoCatalogoNotificacionWebPayload |
        PedidoMenuNotificacionWebPayload): number | null {
        const id = Number(payload.idPedido);
        if (!Number.isSafeInteger(id) || id <= 0) {
            this.showWarning('El payload de la notificación no contiene un identificador válido.');
            return null;
        }
        return id;
    }

    private showWarning(detail: string): void {
        this.messageService.add({
            severity: 'warn',
            summary: 'Notificación',
            detail
        });
    }
}
